import React from "react";
import { Admin, Resource, resolveBrowserLocale } from "react-admin";
import polyglotI18nProvider from "ra-i18n-polyglot";
import authProvider from "./synapse/authProvider";
import dataIntermediaryProvider from "./synapse/intermediaryDataProvider";
import { UserRolesPermissions } from "./components/userRolesPermissions";
import LoginPage from "./components/LoginPage";
import germanMessages from "./i18n/de";
import englishMessages from "./i18n/en";
import CustomLayout from "./components/custom/layout/CustomLayout";
import { CustomRoutes } from "./components/custom/layout/CustomRoutes";
import { CustomTheme } from "./components/custom/layout/CustomTheme";
import CustomFooter from "./components/custom/layout/CustomFooter";
import AssignmentIndIcon from "@material-ui/icons/AssignmentInd";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import UserEditComponent from "./components/UserEditComponent";
import { createBrowserHistory } from "history";

const history = createBrowserHistory();

// TODO: Can we use lazy loading together with browser locale?
const messages = {
  de: germanMessages,
  en: englishMessages,
};
const i18nProvider = polyglotI18nProvider(
  locale => (messages[locale] ? messages[locale] : messages.de),
  resolveBrowserLocale()
);

const App = () => (
  <>
    <Admin
      history={history}
      layout={CustomLayout}
      theme={CustomTheme}
      disableTelemetry
      loginPage={LoginPage}
      authProvider={authProvider}
      dataProvider={dataIntermediaryProvider}
      i18nProvider={i18nProvider}
      customRoutes={CustomRoutes}
    >
      {/* Deactivated as part of the ticket: https://sdui.atlassian.net/browse/BYCS-3271
      Both table views are now merged into one.
      <Resource
        name="users"
        list={UserList}
        edit={UserEdit}
        icon={AssignmentIndIcon}
      /> */}

      <Resource
        name="users"
        list={UserRolesPermissions}
        edit={UserEditComponent}
        icon={AssignmentIndIcon}
      />

      <Resource name="servernotices" />
      <Resource name="devices" />
      <CustomFooter />
      <ToastContainer
        position="bottom-center"
        autoClose={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        theme="colored"
        style={{ fontFamily: "Atkinson Hyperlegible" }}
      />
    </Admin>
  </>
);
export default App;
